( function( $, document, window ) {
	'use strict';

	$( function() {
        $( '.js-team-card-link' ).fancybox({
            backFocus: false,
            autoFocus: false,
        } );

        const swiper = new Swiper( '.js-team-collection', {
            direction: 'horizontal',
			slidesPerView: 1.125,
			spaceBetween: 20,

            navigation: {
                prevEl: '.js-team-collection-prev',
                nextEl: '.js-team-collection-next',
            },

            breakpoints: {
                580: {
                    slidesPerView: 2.25,
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: 3.25,
                },
                1440: {
                    slidesPerView: 4.25,
                }
            },
        } );
	} );
} )( jQuery, document, window );
